import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { VendorService } from '../../../services/vendor.service';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { CustomerService } from '../../../services/customer.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TermscodeLookupComponent } from '../termscode-lookup/termscode-lookup.component';

@Component({
  selector: 'app-create-quick-vendor-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './create-quick-vendor-lookup.component.html',
  styleUrl: './create-quick-vendor-lookup.component.scss'
})
export class CreateQuickVendorLookupComponent implements OnInit {
  @Output() VendorId = new EventEmitter<any>();
  constructor(public dialogService: DialogService, private messageService: MessageService, private vendorservice: VendorService, private customerService: CustomerService) { }

  submitted: boolean = false;
  loader: boolean = false;
  stateList: any[] = [];
  filterStates: any[] = [];
  ref: DynamicDialogRef = new DynamicDialogRef;
  isEditMode: boolean = false;

  vendorForm = new FormGroup({
    vendorName: new FormControl('', Validators.required),
    vendorCode: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]*$/)]),
    manualEntry: new FormControl(false),
    vendorImage: new FormControl(),
    vendorDescription: new FormControl(''),
    isActive: new FormControl(true),
    isInventoryVendor: new FormControl(true),
    isInternalVendor: new FormControl(false),
    termsCode: new FormControl(),
    address: new FormGroup({
      addressLine1: new FormControl('', Validators.required),
      addressLine2: new FormControl(''),
      city: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      zip: new FormControl('', [Validators.required, Validators.pattern(/^\d{6}$/)]),
      country: new FormControl('India', Validators.required),
      stateCode: new FormControl(''),
      CreatedBy: new FormControl(''),
      UpdatedBy: new FormControl(''),
    }),
    phone: new FormControl('', Validators.pattern(/^\d{10}$/)),

    mobile: new FormControl('', [Validators.pattern(/^\d{10}$/)]),
    email: new FormControl('', Validators.email),
    website: new FormControl(''),
    tags: new FormControl(''),
    gstin: new FormControl(''),
    createdBy: new FormControl(''),
    upatedBy: new FormControl('')
  });

  ngOnInit(): void {
    this.manualEntry();
    this.getStateList();
  }

  get formControls() {
    return this.vendorForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.vendorForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }

    return isValid;
  }

  checkVendorCode() {
    if (!this.vendorForm.controls.vendorCode.value) {
      return;
    }

    this.vendorservice.checkVendorCode(this.vendorForm.controls.vendorCode.value).subscribe(
      (data: any) => {
        if (data.success == true) {
          // console.log(data);
        } else {
          this.vendorForm.controls.vendorCode.setValue('');
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
          this.vendorForm.controls.manualEntry.setValue(true);
        }
      },
      (error: any) => {
        console.log(error);
      });

  }

  manualEntry() {
    const manualEntryValue = this.vendorForm.controls.manualEntry.value;
    if (manualEntryValue === true) {
      this.vendorForm.controls.vendorCode.setValue('');
    } else {
      this.getVendorCode();
    }
  }

  getVendorCode() {
    this.loader = true;
    this.vendorservice.autogenerateVendorCode().subscribe({
      next: (data: any) => {
        // const alphanumericCode = 'V';
        // const vendorCode = alphanumericCode + data;
        this.vendorForm.controls.vendorCode.setValue(data.fullNumber);
        this.loader = false;
      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    });
  }

  /*getStateList() {
    this.loader = true;
    this.customerService.getStateList().subscribe({
      next: (data: any) => {
        this.stateList = data;
        this.loader = false;
      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    });
  }*/


     getStateList() 
  {
  this.customerService.getStateList().subscribe({
    next: (data: any) => {
      this.stateList = (data ?? []).sort((a: any, b: any) =>
        (a.stateName ?? a.name ?? a.label ?? '').localeCompare(
          b.stateName ?? b.name ?? b.label ?? ''
        )
      );
    },
    error: error => {
      console.log(error);
    }
  });
}

  filterState(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.stateList as any[]).length; i++) {
      let state = (this.stateList as any[])[i];
      if (state.stateName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(state);
      }
    }

    this.filterStates = filtered;
  }

  // setState(event: any) {
  //   this.vendorForm.controls.address.controls.state.setValue(event.value.stateName);
  //   this.vendorForm.controls.gstin.setValue(event.value.stateCode);
  // }
  setState(event: any) {
    this.vendorForm.patchValue({
      gstin: event.value.stateCode,
      address: {
        state: event.value.stateName,
        stateCode: event.value.stateCode,
        CreatedBy: localStorage.getItem('username'),
      }
    });
    if (this.isEditMode) {
      this.vendorForm.patchValue({
        gstin: event.value.stateCode,
        address: {
          state: event.value.stateName,
          stateCode: event.value.stateCode,
          UpdatedBy: localStorage.getItem('username'),
        }
      });
    }
  }

  checkState() {
    const enteredState = this.vendorForm.controls.address.controls.state.value;
    const validStates = this.stateList.map(state => state.stateName);

    if (validStates.includes(enteredState)) {
    } else {
      this.vendorForm.controls.address.controls.state.setValue('');
    }
  }

  validater() {
    const customerCodeControl = this.vendorForm.get('vendorCode');
    const mobileControl = this.vendorForm.get('mobile');
    if (mobileControl?.invalid) {
      if (mobileControl.errors?.['pattern']) { }
      if (mobileControl.errors?.['maxlength']) { }
    }
    if (customerCodeControl?.invalid) {
      if (customerCodeControl.errors?.['required']) {
      }
      if (customerCodeControl.errors?.['pattern']) {
      }
    }
  }

  createVendor(data: any) {

    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    this.loader = true;
    const username = localStorage.getItem('username');
    data.createdBy = username;
    this.vendorservice.createVendor(data).subscribe({
      next: (data: any) => {
        if (data.success == true) {
          this.loader = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: data.message });
          this.VendorId.emit(data.vendorId);

        } else {
          this.loader = false;
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
        }
      },
      error: (error: any) => {
        console.error('Error creating vendor:', error);
        this.loader = false;
      }
    });
  }
  getTermsCode() {
    this.ref = this.dialogService.open(TermscodeLookupComponent, {
      header: 'Terms Code',
      width: '80%',
    })
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.vendorForm.patchValue({
          termsCode: data.paymentTermsDescription
        })
      }
    })
  }

}
